import { type ReactElement } from 'react';
import { NeonButton, NeonButtonFooter } from '@ps-refarch-ux/neon';
import { NeonButtonTypes } from '@/constants/neon-constants';
import styles from '@/components/MultiSectionFormLayout/multi-section-form-layout.module.scss';

export interface StickyFormFooterTertiaryButton {
  id: string;
  text: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface StickyFormFooterProps {
  cancelLabel: string;
  saveLabel: string;
  onCancel: () => void;
  onSave: () => void;
  saveDisabled: boolean;
  /**
   * When provided, `saveLabel` renders as a secondary button and this becomes
   * the rightmost primary button (e.g. "Save and Map to Schools" on Course creation).
   */
  primaryButton?: StickyFormFooterTertiaryButton;
  tertiaryButton?: StickyFormFooterTertiaryButton;
  footerId?: string;
  cancelButtonId?: string;
  saveButtonId?: string;
}

export function StickyFormFooter({
  cancelLabel,
  saveLabel,
  onCancel,
  onSave,
  saveDisabled,
  primaryButton,
  tertiaryButton,
  footerId = 'create-plan-form-footer',
  cancelButtonId = 'create-plan-form-cancel',
  saveButtonId = 'create-plan-form-save',
}: StickyFormFooterProps): ReactElement {
  return (
    <div className={styles.formFooterBar} data-slot="sticky-footer">
      <div className={styles.footerInner}>
        <div className={styles.footerLeft}>
          {tertiaryButton && (
            <NeonButton
              id={tertiaryButton.id}
              dataType={NeonButtonTypes.Tertiary}
              dataText={tertiaryButton.text}
              dataAriaLabel={tertiaryButton.text}
              disabled={tertiaryButton.disabled}
              onClick={tertiaryButton.onClick}
            />
          )}
        </div>
        <div className={styles.footerButtons}>
          <NeonButtonFooter
            id={footerId}
            buttons={[
              {
                id: cancelButtonId,
                text: cancelLabel,
                type: 'borderless',
                onClick: onCancel,
              },
              ...(primaryButton
                ? [
                    {
                      id: saveButtonId,
                      text: saveLabel,
                      type: NeonButtonTypes.Secondary,
                      disabled: saveDisabled,
                      onClick: onSave,
                    },
                  ]
                : []),
            ]}
            primaryButton={
              primaryButton
                ? {
                    id: primaryButton.id,
                    text: primaryButton.text,
                    type: 'primary',
                    disabled: primaryButton.disabled,
                    onClick: primaryButton.onClick,
                  }
                : {
                    id: saveButtonId,
                    text: saveLabel,
                    type: 'primary',
                    disabled: saveDisabled,
                    onClick: onSave,
                  }
            }
          />
        </div>
      </div>
    </div>
  );
}
